// Automatisches Backup beim Schließen/Ausblenden der App.
// Registriert visibilitychange + pagehide Listener.
// Throttle: max. 1× alle 15 Minuten um Tab-Wechsel nicht zu überlasten.

import { uploadDriveBackup, isDriveConnected } from './googleDriveBackup';
import { writeLocalBackup, getLocalFolderName } from './localBackupService';

const MIN_INTERVAL_MS = 15 * 60 * 1000;

let lastAutoBackup    = 0;
let pendingDriveSync  = false; // Drive-Upload war offline ausstehend

async function triggerAutoBackup(): Promise<void> {
  const now = Date.now();
  if (now - lastAutoBackup < MIN_INTERVAL_MS) return;
  lastAutoBackup = now;

  if (isDriveConnected()) {
    uploadDriveBackup()
      .then(() => { pendingDriveSync = false; })
      .catch(() => {
        if (!navigator.onLine) pendingDriveSync = true;
      });
  }

  const folder = await getLocalFolderName();
  if (folder !== null) {
    void writeLocalBackup().catch(() => { /* silent */ });
  }
}

export function setupAutoBackupOnClose(): () => void {
  const onVisibility = (): void => {
    if (document.visibilityState === 'hidden') void triggerAutoBackup();
  };

  const onPageHide = (): void => { void triggerAutoBackup(); };

  const onOnline = (): void => {
    if (pendingDriveSync && isDriveConnected()) {
      pendingDriveSync = false;
      void uploadDriveBackup().catch(() => { pendingDriveSync = true; });
    }
  };

  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pagehide',  onPageHide);
  window.addEventListener('online',    onOnline);

  return (): void => {
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('pagehide', onPageHide);
    window.removeEventListener('online',   onOnline);
  };
}
